import React from 'react';
import CurrencyConvert from './CurrencyConvert';
import DashboardPurchase from './DasboardPurchase';
import DashboardSales from './DashboardSales';
import DashboardStatus from './DashboardStatus';

export function DashboardPage() {
  return (
    <div className="row">
      <div className="col-xl-6">
        <DashboardSales className="gutter-b card-stretch" />
      </div>
      <div className="col-xl-6">
        <DashboardPurchase className="gutter-b card-stretch" />
      </div>
      <div className="col-xl-6">
        <DashboardStatus className="gutter-b card-stretch" />
      </div>
      <div className="col-xl-6">
        <CurrencyConvert className="gutter-b card-stretch" />
      </div>
    </div>
  );
}
